<div class="menuTypes">
  @if (title && filteredNodes.length) {
    <h2 class="node-type-title">{{ title }}</h2>
  }
  @for (node of filteredNodes; track node) {
    <div [draggable]="true" class="right-sidebar-step"
      (dragstart)="dragstart($event, node)"
      >
      <div class="step-info-block">
        <div id="dragImage" >
          <img class="step-icon" [src]="node?.image.primary" appFallbackImage [nodeType]="node?.nodeType"/>
        </div>
        <div class="step-data">
          <p class="step-title">{{node?.title}}</p>
          <div class="step-description">
            {{node?.description}}
            <a href="{{node?.nodeInfoSrc}}" target="_blank">More info</a>
          </div>
        </div>
      </div>
      @switch (node?.supported_channel) {
        @case ('apple') {
          <img src='../../../../../assets/svg/redesign/apple.svg' alt="apple"/>
        }
        @case ('whatsapp') {
          <img src='../../../../../assets/svg/redesign/whatsapp.svg' alt="whatsapp"/>
        }
      }
    </div>
  }
</div>
